import { CheckCircle } from 'lucide-react';
import SectionReveal from './SectionReveal';

const partners = [
  "European Investment Bank",
  "EBRD",
  "Goldman Sachs",
  "BlackRock",
  "IFC World Bank",
  "Macquarie Asset Management",
  "Allianz Global Investors",
  "Credit Agricole CIB",
  "BNP Paribas",
  "UniCredit Group",
  "European Investment Fund",
  "ING Capital",
  "JSB China",
  "Great Power China",
  "NR China",
  "Actual Connect",
  "GreenVolt Romania",
];

const certifications = [
  "EU Taxonomy Aligned",
  "Green Bond Principles",
  "TCFD Compliant",
  "Science Based Targets",
  "PRI Signatory",
  "RE100 Committed",
  "UN SDG Aligned",
  "ISO 50001",
  "GRESB Certified",
  "LSEG Green Bond Framework",
];

const FADE_MASK     = 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)';
const CERT_STYLE_BASE = { border: '1px solid rgba(212,160,23,0.25)', color: 'rgba(212,160,23,0.65)', background: 'rgba(212,160,23,0.04)', letterSpacing: '0.1em' };
const CERT_STYLE_HOVER = { borderColor: 'rgba(212,160,23,0.6)', color: '#D4A017', background: 'rgba(212,160,23,0.08)' };

function PartnerRow() {
  return (
    <div className="relative overflow-hidden mb-5" style={{ maskImage: FADE_MASK }}>
      <div className="flex animate-marquee whitespace-nowrap">
        {[...partners, ...partners].map((partner, i) => (
          <div key={`partner-${i < partners.length ? 'a' : 'b'}-${partner}`} className="mx-10 flex items-center py-3">
            <span
              className="text-sm sm:text-base font-medium text-white/30 hover:text-white/70 transition-colors duration-200 tracking-widest uppercase cursor-default"
              data-testid={i < partners.length ? `partner-${i}` : undefined}
            >
              {partner}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function CertRow() {
  return (
    <div className="relative overflow-hidden" style={{ maskImage: FADE_MASK }}>
      <div className="flex animate-marquee-reverse whitespace-nowrap">
        {[...certifications, ...certifications].map((cert, i) => (
          <div key={`cert-${i < certifications.length ? 'a' : 'b'}-${cert}`} className="mx-3 flex items-center py-2">
            <span
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium tracking-wider uppercase cursor-default transition-all duration-200"
              style={CERT_STYLE_BASE}
              onMouseEnter={e => Object.assign(e.currentTarget.style, CERT_STYLE_HOVER)}
              onMouseLeave={e => Object.assign(e.currentTarget.style, CERT_STYLE_BASE)}
            >
              <CheckCircle size={10} strokeWidth={2.5} />
              {cert}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PartnersSection({ text }) {
  return (
    <section id="partners" className="py-24 sm:py-32 bg-[#0a0a0a] overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl mb-14">
        <SectionReveal>
          <p className="text-xs tracking-[0.28em] uppercase text-[#D4A017] mb-4 font-medium text-center">{text.label}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-white text-center" style={{ fontFamily: "'Outfit', sans-serif" }}>{text.title}</h2>
        </SectionReveal>
      </div>
      <PartnerRow />
      <CertRow />
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl mt-14">
        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>
    </section>
  );
}
